import React, { useEffect, useState } from 'react';
import { ShimmerThumbnail, ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";

const NotificationListContentLoader = () => {
  const [numberOfItems, setNumberOfItems] = useState(calculateNumberOfItems());
  function calculateNumberOfItems() {
    return Math.floor((window.innerHeight - 50) / 60);
  }

  useEffect(() => {
    const handleResize = () => {
      setNumberOfItems(calculateNumberOfItems());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <>
      {
        Array.from({ length: numberOfItems }).map((_, index) => {
          return (
            <div className={`pd-x-20 ${index === numberOfItems - 1 ? '' : 'pd-b-12 mg-b-12 border-bottom border-gray-600'}`}>
              <div className="d-flex align-items-center">
                <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
                <div className='flex-1'>
                  <div className='d-flex mg-b-5'>
                    <div className='flex-1'>
                      <div style={{ width: '87px' }} >
                        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" />
                      </div>
                    </div>
                    <div style={{ width: '54px' }}  className='shimmer-height-12'>
                      <ShimmerTitle line={1} gap={0} height={11} variant="primary" className="mg-l-10 mg-b-0 d-block" />
                    </div>
                  </div>
                  <div style={{ width: '80%' }}>
                    <ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" />
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }
    </>
  );
};

export default NotificationListContentLoader;
